/**
 * One-shot, in-memory marker set by the signup screen so the auth layout can
 * route a brand-new account to the plans screen (/upgrade) instead of the
 * dashboard — install → sign up → plans → subscribe or skip.
 *
 * Deliberately not persisted: an app restart (or the 60s window lapsing)
 * falls back to the normal /courses redirect. Cleared on signup failure so a
 * subsequent login never inherits it.
 */

const WINDOW_MS = 60_000;

let markedAt: number | null = null;

export function markFreshSignup(): void {
  markedAt = Date.now();
}

export function clearFreshSignup(): void {
  markedAt = null;
}

export function isFreshSignup(): boolean {
  return markedAt !== null && Date.now() - markedAt < WINDOW_MS;
}
